// kyc update

import React, { useState, useEffect, useRef } from "react";
import {View, Image, Text, TouchableOpacity, TextInput,Dimensions, ScrollView, FlatList,} from "react-native";
import { tagClosureFilter, sendOtp, validateOtpWithToken,} from "./../../api/apiManager";
import {  getAllVehiclesListForClosureTag,} from "./../../api/serviceRequest";
import ModalAlert from "../../common/ModalAlert";
import CustomButton from "../../common/CustomButton";
import { get, isElement, isEmpty } from "lodash";
import Loader from "../../common/Loader";
import CText from "../../common/CText";
import CView from "../../common/CView";
import CButton from "../../common/CButton";
import CHeader from "../../common/CHeader";
import CImage from "../../common/CImage";
import QuickLinks from "../Profile/QuickLinks";
import CustomInput from "../../common/CustomInput";
import ModalAlertMultipleButtons from "../../common/ModalAlertMultipleButtons";
import * as RootNavigation from "../../utilities/RootNavigation";
import CountdownTimer from "../../common/CTimer.web";
import useStyles from "./SelectVehicleForCloseTag_Styles";
import SelectVehicleForNPCICloseTag from "./SelectVehicleForNPCICloseTag.web";
import { useLocation } from "react-router-dom";

const isSmallDevice = Dimensions.get("window").width < 767;
const isTabView =Dimensions.get("window").width > 767 && Dimensions.get("window").width < 1024;

export default function SelectVehicleForCloseTag(props) {
  const { state} = useLocation()
  const isForcefulTagClosure = state?.isForcefulTagClosure || false
  const vehicleListForClousure =  state?.vehicleList || false

  const styles = useStyles();
  const otpPattern = /^\d{6}$/;
  const [loading, setLoading] = useState(false);
  const counterRef = useRef(null);
  const [vehicleList, setVehicleList] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [targetVrn, setTargetVrn] = useState("");
  const [isTagCloseModalEnable, setTagCloseModalEnable] = useState("");
  const [alertModalVisible, setAlertModalVisible] = useState(false);
  const [otpModalVisible, setOtpModalVisible] = useState(false);
  const [otp, setOtp] = useState();
  const [requestId, setRequestId] = useState("");
  const [otpMsg, setOtpMsg] = useState("");
  const [alertModal, setAlertModal] = useState({
    title: "",
    status: "",
    message: "",
    navigateScreen: "",
    actionButton: "",
  });

  const onCloseModal = () => {
    setAlertModalVisible(false);
  };

  useEffect(() => {
    getAllVehiclesListCloseTag();
  }, []);

  const getAllVehiclesListCloseTag = () => {
    if(isForcefulTagClosure){
      setVehicleList(vehicleListForClousure)
    }else{
      setLoading(true);
      getAllVehiclesListForClosureTag()
        .then((res) => {
          if (res && !isEmpty(res)) {
            setVehicleList(res);
            setLoading(false);
          }
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
          console.log("<------------ error in tag details ----------->");
        });
    }
  };

  useEffect(() => {
    if (searchText && searchText.length > 2) {
      searchFilter();
    } else if ((searchText && searchText.length < 2) || searchText == "") {
      getAllVehiclesListCloseTag();
    }
  }, [searchText]);

  const searchFilter = () => {
    setLoading(true);
    let req = {
      vrn: searchText,
      // assignedVrnList: null,
    };
    tagClosureFilter(req)
      .then((res) => {
        setVehicleList(res?.data || []);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.log("<------------ error in tag details ----------->");
      });
  };

  const vehicleSelelctionForCredit = (params) => {
    setTargetVrn(params.toVrn);
  };

  const getOtp = () => {
    console.log(props.selectedVrnData);
    var params = {
      id: global.userCd,
      type: "tagClosure",
    };
    setLoading(true);
    sendOtp(params)
      .then((response) => {
        let res = response?.data;
        if (res.statusCode == 1003 || res.statusCode == 200) {
          setLoading(false);
          setRequestId(res?.response);
          setOtpMsg(res.message);
          setOtpModalVisible(true);
        } else if (
          res.statusCode == -1052 ||
          res.statusCode == 500 ||
          res.statusCode == -1017 ||
          res.statusCode == -1003 ||
          res.statusCode == -1004 ||
          res.statusCode == -1100
        ) {
          setAlertModal({
            title: "Error",
            status: "error",
            message: res.message,
            navigateScreen: "",
            actionButton: "OK",
          });
          setAlertModalVisible(true);
          setLoading(false);
          setOtpModalVisible(true);
        }
      })
      .catch((err) => {
        setAlertModal({
          title: "Error",
          status: "error",
          message: err.message,
          navigateScreen: "",
          actionButton: "OK",
        });
        setAlertModalVisible(true);
        setLoading(false);
      });
  };

  const onClickValidateOtp = () => {
    let reqObj = {
      requestId: requestId?.otp,
      otp: otp,
      type: "tagClosure",
    };
    setLoading(true);
    validateOtpWithToken(reqObj)
      .then((res) => {
        setOtp("");
        if (
          res.statusCode == 200 ||
          res.statusCode == 1020 ||
          res.statusCode == 1034 ||
          res.statusCode == 1053 ||
          res.statusCode == 1008
        ) {
          setLoading(false);
          setOtpModalVisible(false);
          setAlertModal({
            title: "Successful",
            status: "success",
            message: res.message,
            navigateScreen: "",
            actionButton: "OK",
          });
          setAlertModalVisible(true);
          RootNavigation.navigate("ServiceRequest/TagClosure", {
            selectedVehicle: targetVrn,
            vehicleLength: vehicleList?.length,
            isForcefulTagClosure : isForcefulTagClosure
          });
        } else if (
          res.statusCode == -1020 ||
          res.statusCode == 500 ||
          res.statusCode == -1008 ||
          res.statusCode == -1053 ||
          res.statusCode == -1017 ||
          res.statusCode < 0
        ) {
          setOtpModalVisible(false);
          setAlertModal({
            title: "Error",
            status: "error",
            message: res.message,
            navigateScreen: "",
            actionButton: "OK",
          });
          setAlertModalVisible(true);
          setLoading(false);
        } else {
          setOtpModalVisible(false);
          setAlertModal({
            title: "Error",
            status: "error",
            message: res.message,
            navigateScreen: "",
            actionButton: "OK",
          });
          setAlertModalVisible(true);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log("ERROR ", err);
        setOtpModalVisible(false);
        setAlertModal({
          title: "Error",
          status: "error",
          message: err.message,
          navigateScreen: "",
          actionButton: "OK",
        });
        setAlertModalVisible(true);
        setLoading(false);
      });
  };
  const onNpciCloseTagClick = (params)=>{
    setTargetVrn(params);
    getOtp()
  }

  return (
    <>
     
      {isForcefulTagClosure ? <SelectVehicleForNPCICloseTag  onProceed = {onNpciCloseTagClick} vehicleList={vehicleListForClousure} /> :<>
      <View style={styles.container}>
        <View style={styles.closurePolicyWidget}>
          <Text style={styles.closurePolicyText}>
            {"FASTag Account(s) will be closed in 12 day(S) from the date of Approval of the closure request."}
          </Text>
          <CView FR AC>
            <CButton
              title={"Closure Policy"}
              onPress={()=> console.log('')}
              style={styles.cancelBtn}
            ></CButton>
            <TouchableOpacity>
              <Text style={styles.closeText}>X</Text>
            </TouchableOpacity>
          </CView>
        </View>
        <View style={styles.navWidget}>
          <View style={styles.contentSpace}>
            <CHeader
              title="Tag Closure"
              onPress={() => {
                RootNavigation.navigate("ServiceRequest");
              }}
            />
            <Text style={styles.backTextDesc}>
              {"Please select a Tag Account No. for closing tag account."}
            </Text>
          </View>
          <View style={styles.closureDocWidget}>
            <CButton
              isDisabled={targetVrn == ""}
              onPress={() => {
                getOtp();
                setTagCloseModalEnable(false);
              }}
              title={"Close Tag"}
              style={styles.closeTagBtn}
            />
          </View>
        </View>
        <View style={styles.contentWidget}>
          {searchText == "" && vehicleList.length === 0 ? null : (
            <View style={styles.searchWidget}>
              <TouchableOpacity style={styles.searchIconContainerStyle}>
                <CImage.IconSearch></CImage.IconSearch>
              </TouchableOpacity>
              <CustomInput
                label={"Search "}
                onValueChanged={(t) => {
                  setSearchText(t);
                }}
                value={searchText}
                placeholder={"Vehicle Reg No."}
                style={{ height: 33, marginLeft: 10 }}
              />
            </View>
          )}
          <ScrollView
            showsHorizontalScrollIndicator={false}
            horizontal={true}
            style={[styles.scrollViewStyle]}
          >
            <FlatList
              extraData
              style={styles.flatListStyle}
              data={isEmpty(vehicleList) ? [] : vehicleList}
              key={vehicleList.length}
              renderItem={({ item }) => {
                return (
                  <CView style={styles.viewStyle}>
                    <CImage.CarImg></CImage.CarImg>
                    <CView style={{ flex: 3, marginRight: 10, marginLeft: 10 }}>
                      <View style={[styles.vehicleViewStyle, { flex: 4 }]}>
                        <CText.vrnText> {get(item, "vrn", "")}</CText.vrnText>
                        <CText.vehicleModal>
                          {" "}
                          {get(item, "vehicleModel", "")}
                        </CText.vehicleModal>
                        <View>
                          {item.status && item.status != "Activated" && (
                            <View style={{flexDirection: "row", alignItems: "center",}} >
                              <Image
                                source={require("../../assets/images/hotlisted_icon.png")
                                }
                                style={{ height: 16, width: 16, top: 0 }}
                              />
                              <Text style={[ styles.lowBalanceText,{
                                    color:"#e9730d"
                                  },
                                ]}
                              >
                                {item.status == "Hotlisted by service provider"
                                  ? "Hotlisted"
                                  : item.status 
                                  }
                              </Text>
                            </View>
                          )}
                        </View>
                      </View>
                      <CView FR AC MT={5}>
                        <CImage.IconToll></CImage.IconToll>
                        <CView style={{ marginLeft: 20 }}>
                          <CText.priceText>
                            {"\u20B9  "}{" "}
                            {get(item, "fastagBalance", "").toFixed(2)}{" "}
                          </CText.priceText>
                          <CText.vehicleModal>
                            {"FASTag Balance"}
                          </CText.vehicleModal>
                        </CView>
                      </CView>
                    </CView>
                    <TouchableOpacity
                      onPress={() => { vehicleSelelctionForCredit({ toVrn: item });}}
                      style={styles.radiobuttonOutSideStyle}>
                      {targetVrn?.fastagId == item.fastagId ? (<CImage.TickActive></CImage.TickActive> ) : null}
                    </TouchableOpacity>
                  </CView>
                );
              }}
              keyExtractor={(item) => item.id}
              numColumns={isSmallDevice ? null : isTabView ? 2 : 3}
            />
          </ScrollView>
        </View>
        <View style={{ marginTop: -30, marginBottom: 30 }}>
          <QuickLinks navigation={props.navigation} />
        </View>  </View>  </> }
     

      {alertModalVisible ? (
        <View style={styles.overlayViewStyle}>
          <ModalAlert
            title={alertModal.title}
            status={alertModal.status}
            message={alertModal.message}
            navigateScreen={alertModal.navigateScreen}
            actionButton={"OK"}
            onCloseModal={onCloseModal}
          />
        </View>
      ) : null}
      {isTagCloseModalEnable ? (
        <View style={styles.overlayViewStyle}>
          <ModalAlertMultipleButtons
            title={"Tag Closure Charges"}
            status={"No Status"}
            bullet={"."}
            bulletMessage={"As per IDFC First Bank’s policy, for any FASTag which has been active for less than 60 days calculated from the Tag Issuance Date, a Tag Closure Charge of ₹ 200 will be applicable. Please click on Yes, I agree to proceed with Tag Closure"}
            checkbox={true}
            cancelButton={"Cancel"}
            proceedButton={"Proceed to close tag"}
            onPressActionButton1={() => { setTagCloseModalEnable(false);}}
            onPressActionButton2={() => {
              getOtp();
              setTagCloseModalEnable(false);
            }}
            backgroundColor={"#bd2d37"}
            color={"#ffffff"}
          />
        </View>
      ) : null}
      {otpModalVisible ? (
        <View style={styles.overlayViewStyle}>
          <View style={styles.overlayContainer}>
            <View style={styles.overlay}>
              <View style={styles.overlayContentViewStyle}>
                <CText.enterOtpText>{"Enter OTP"}</CText.enterOtpText>
                <CText.otpDescText>{otpMsg ? otpMsg : ""}</CText.otpDescText>
                <View style={{ alignSelf: "center" }}>
                  <CustomInput
                    onValueChanged={(e) => setOtp(e)}
                    value={otp}
                    keyboardType="numeric"
                    pattern={/^\d{6}$/}
                    errorMessage={"Enter Valid OTP"}
                    maxLength={6}
                    style={[styles.otpInputViewStyle, { alignSelf: "center" }]}
                  />
                </View>
                <View style={styles.resendViewStyle}>
                  <CountdownTimer
                    requestOtp={otpModalVisible}
                    onClickGetOtp={getOtp}
                    counterRef={counterRef}
                  />
                </View>
                <View style={{
                    width: 123.5,
                    height: 36,
                    alignSelf: "center",
                    marginTop: 20,
                  }}
                >
                  <CustomButton
                    text={"Submit"}
                    onPress={() => {
                      !otpPattern.test(otp) ? "" : onClickValidateOtp();
                    }}
                    disable={!otpPattern.test(otp) ? true : false}
                  />
                </View>
              </View>
            </View>
          </View>
        </View>
      ) : null}
      {loading && <Loader />}
    </>
  );
}

